export class AreaMarker {


    areaid: number;
    marker: any;

    constructor(areaid: number, marker: any) {
        this.areaid = areaid;
        this.marker = marker;
    }
}


// WEBPACK FOOTER //
// ./src/app/utilities/MapControls/AreaMarker.ts